const encode = (data) => {
  return reverse(btoa(unescape(encodeURIComponent(JSON.stringify(data))))) + randomString(7)
}
const encodeAuthen = (data) => {
  data = data + randomString(5)
  return reverse(btoa(unescape(data))) + randomString(10)
}
function reverse (s) {
  return s.split('').reverse().join('')
}

function randomString (num) {
  var text = ''
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (var i = 0; i < num; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}

export default {
  encode,
  encodeAuthen
}



// WEBPACK FOOTER //
// ./src/services/encode.js